import React, { useEffect, useState } from "react";
import { useDragAndDrop } from "@formkit/drag-and-drop/react";
// import { supabase } from "../supabase/client";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import JSZip from "jszip";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { saveAs } from "file-saver";
import { useLogin } from "../context/LoginContext";
import TitleBox from "../components/common/TitleBox";
import ContainerBox from "../components/common/ContainerBox";
import DataList from "../components/common/DataList";
import Loading from "../components/common/Loading";
import { IconImageLine, IconPdfLine } from "../components/icons/Icons";

const ExpedientePage = () => {
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const [links, setLinks] = useState([]);
  const [zip, setZip] = useState(new JSZip());
  const [cantidadArchivos, setCantidadArchivos] = useState(0);
  const [expedientes, setExpedientes] = useState([]);
  const [selectedExp, setSelectedExp] = useState("");
  const [formData, setFormData] = useState([]);
  const [parent, files, setFiles] = useDragAndDrop([]);

  const navigate = useNavigate();
  const { user } = useLogin();

  useEffect(() => {
    getNumeroExpedientes();
  }, []);

  useEffect(() => {
    if (user !== null) {
      navigate("/expediente");
    }
    // getCartas();
  }, [user]);

  //   const handleFileChange = (event) => {
  //     setSelectedFiles(event.target.files);
  //   };

  const getNumeroExpedientes = async () => {
    // UTILIZANDO SUPABASE PARA OBTENER LOS EXPEDIENTES
    // const { error, data } = await supabase.from("process").select(`
    //         id,
    //         num_process,
    //         anio_process,
    //         class_process(name)
    //         }
    //    `);
    // if (error) throw error.message;
    // const expedientesData = data.map((item) => {
    //   return {
    //     value: item.id,
    //     label:
    //       item.num_process +
    //       "-" +
    //       item.anio_process +
    //       "-" +
    //       item.class_process.name,
    //   };
    // });
    // setExpedientes(expedientesData);
    // UTILIZANDO UNA API PARA OBTENER LOS EXPEDIENTES
    const response = await fetch(
      "https://www.arbitrajeccia.com.pe/sistema/restallfiles"
    );
    const data = await response.json();
    const expedientesData = data.data.map((item) => {
      return {
        value: item.iddatos_caso,
        label:
          item.numero_expediente_nro +
          "-" +
          item.numero_expediente_anio +
          "-" +
          item.numero_expediente_letras,
      };
    });
    const uniqueValuesArray = [...new Set(expedientesData)];
    setExpedientes(uniqueValuesArray);
  };

  const getArchivosExpediente = async (id) => {
    const response = await fetch(
      "https://www.arbitrajeccia.com.pe/sistema/restallfiles/" + id
    );
    const data = await response.json();
    if (data.code === 500) {
      setCantidadArchivos(0);
      setLinks([]);
      return;
    }
    const dataOrder = data.data.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateB - dateA;
    });
    // const linkArchivos = dataOrder.map((item) => item.file_path);
    setCantidadArchivos(data.amount);
    setFiles(dataOrder);
    setLinks(dataOrder);
  };

  const handleDataListChange = async (e, name) => {
    setFormData(() => ({
      ...formData,
      [name]: e.value,
    }));
    await getArchivosExpediente(e.value);
  };

  const handleDownload = async () => {
    setLoading(true);
    const linkArchivos = files.map((item) => item.file_path);
    for (let i = 0; i < linkArchivos.length; i++) {
      try {
        const fileName = linkArchivos[i].split("/").pop();
        if (fileName !== "-" && fileName.includes(".pdf")) {
          const response = await axios.get(linkArchivos[i], { responseType: "blob" });
          if (response.status === 200) {
            const fileBlob = new Blob([response.data]);
            zip.file(String(i).padStart(4, '0')+"_"+fileName, fileBlob);
          }
        }
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const response = error.response;
          if (response.status === 404) {
            try {
              const res = await axios.get(
                "https://ccia-arbitraje.nyc3.digitaloceanspaces.com/" +
                  linkArchivos[i].split("/").slice(-2).join("/"),
                { responseType: "blob" }
              );
              if (res.status === 200) {
                const fileBlob = new Blob([res.data]);
                zip.file(String(i).padStart(4, '0')+"_"+linkArchivos[i].split("/").slice(-1), fileBlob);
              }
            } catch (error) {
              console.log("No se encontró el archivo");
            }
          }
        }
      }
    }

    const content = await zip.generateAsync({ type: "blob" });
    saveAs(content, "archivos.zip");
    setLoading(false);
    setLinks([]);
    setFiles([]);
    setCantidadArchivos(0);
    setFormData([]);
    setSelectedExp("");
    MySwal.fire({
      title: "Expediente Digital",
      text: "Descarga completada",
      icon: "success",
    });
  };

  return (
    <>
      {loading && <Loading />}
      <TitleBox title="Expediente digital" />
      <ContainerBox>
        <div className="flex items-center justify-between">
          <p>Selecciona el expediente para realizar la busqueda</p>
          <button
            onClick={handleDownload}
            disabled={links.length === 0}
            className="py-2 px-4 bg-primary text-white rounded-md disabled:bg-primary/50 disabled:cursor-not-allowed hover:bg-primary/90 transition-all duration-300"
          >
            Descargar todo
          </button>
        </div>
        <DataList
          textLabel={"Expediente"}
          name={"process_id"}
          className="w-3/4"
          value={selectedExp}
          dataOptions={expedientes}
          onChange={(e) => {
            handleDataListChange(e, "process_id");
            const filterData = expedientes.filter(
              (item) => item.value === e.value
            );
            setSelectedExp(filterData[0]);
          }}
        />
        <p className="text-lg">
          Cantidad de archivos encontrados: {cantidadArchivos}
        </p>
        <div ref={parent} className="flex flex-wrap gap-5 justify-center">
          {files.map((tape, index) => (
            <div
              className="w-44 h-44 bg-gray-100 text-xs p-2 flex flex-col items-end justify-end overflow-hidden cursor-pointer relative rounded-lg border border-gray-200 hover:border-primary transition-all duration-300 shadow-md"
              data-label={tape.file}
              key={index}
            >
              {
                tape.file_path.split(".").pop() === "pdf" ? (
                  <IconPdfLine className="w-12 fill-gray-400 absolute top-3 right-3" />
                ) : (
                  <IconImageLine className="w-12 fill-gray-400 absolute top-3 right-3" />
                )
              }
              <div className="flex items-center justify-between w-full mb-2">
                <span
                  className={`uppercase font-medium ${
                    tape.type === "ESCRITOS" && "bg-green-600"
                  } ${tape.type === "CARTAS" && "bg-red-600"} ${
                    tape.type === "RESOLUCIONES" && "bg-orange-500"
                  } ${
                    tape.type === "NOTIFICACIONES" && "bg-blue-600"
                  } text-white text-[8px] p-1 rounded-lg`}
                >
                  {tape.type}
                </span>
                <span className="uppercase font-medium bg-black/80 text-white text-[8px] p-1 rounded-lg">
                  {new Date(tape.date).toLocaleDateString("es-PE", {
                    year: "numeric",
                    month: "short",
                    day: "2-digit",
                  })}
                </span>
              </div>
              <a
                href={tape.file_path}
                target="_blank"
                rel="noreferrer"
                className="hover:text-primary block w-full"
              >
                {tape.name}
              </a>
            </div>
          ))}
        </div>
      </ContainerBox>
    </>
  );
};

export default ExpedientePage;
